@if (groupedNotification !== undefined) {
  @let first = groupedNotification.notifications[0];
  <div class="notification mb-2 rounded-box" tabindex="0" [ngClass]="first.isRead ? 'read' : 'unread'">
    <div class="flex flex-col items-start px-4 py-2">
      <span class="flex w-full items-center">
        <daisy-avatar class="shrink-0" [initials]="(first.sender?.firstInitial ?? '') + (first.sender?.lastInitial ?? '')" size="2.25rem" shape="rounded" />
        <div class="ml-3 flex w-full flex-col">
          <div class="flex items-center justify-between">
            <div>
              <span>{{ first.sender?.displayName }}</span>
              <span class="items-center">
                {{ first.content?.primaryText }}
              </span>
              <a class="cursor-pointer font-bold text-daisy-primary"
                [routerLink]="first.content?.primaryUrl | routerLinkSafeUrl" daisyTooltip="Navigate to Review"
                (click)="onHyperLinkClick(first, $event)"
                target="_blank" rel="noopener noreferrer">
                @if (first.category === NotificationCategory.NarrativeReviews) {
                  Narrative
                }
                @else {
                  Incident
                }
                Review {{ first.content?.primaryUrl | urlSegment: 'reviews' }}</a>
            </div>
            <div class="h-12 shrink-0">
              @if (first.isRead) {
                <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-sm text-base-content/60"
                  aria-label="Mark as unread" daisyTooltip="Mark as unread"
                  (click)="onMarkNotificationsReadStatusesClick(groupedNotification.notifications, false, $event)">
                  <i class="fa-regular fa-circle"></i>
                </button>
              } @else {
                <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-sm text-daisy-primary"
                  aria-label="Mark as read" daisyTooltip="Mark as read"
                  (click)="onMarkNotificationsReadStatusesClick(groupedNotification.notifications, true, $event)">
                  <i class="fa-solid fa-circle"></i>
                </button>
              }
            </div>
          </div>
          <div class="my-1 flex justify-between">
            <a class="cursor-pointer font-bold uppercase text-daisy-primary" (click)="onHyperLinkClick(first, $event)"
              [routerLink]="first.content?.secondaryUrl | routerLinkSafeUrl" daisyTooltip="Navigate to Incident"
              target="_blank" rel="noopener noreferrer">
              <i class="fa-solid fa-file-lines"></i>
              {{ first.content?.secondaryText }}</a>
            <span class="text-base-content/60">
              {{ first.createdOn | timeAgo }}
            </span>
          </div>
        </div>
      </span>

      @if (groupedNotification.count > 1) {
        <div class="mb-2 w-full">
          <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-sm h-auto w-full justify-start gap-4 p-3 font-normal"
            [attr.aria-expanded]="isExpanded" (click)="toggleExpansion()">
            <i class="fa-solid fa-chevron-right text-base-content/60 transition-transform duration-200" [class.rotate-90]="isExpanded"></i>
            <daisy-avatar [initials]="'+' + (groupedNotification.count - 1)" size="2rem" shape="rounded" color="neutral" />
            <span class="text-sm font-semibold">similar notifications</span>
          </button>

          @if (isExpanded) {
            <div class="mt-2 border-l-2 border-[var(--color-primary)] pl-2">
              @for (notification of groupedNotification.notifications.slice(1); track notification) {
                <div class="mb-2 flex w-full items-center px-4">
                  <span class="notification flex w-full items-center rounded-box px-4 py-3" tabindex="0"
                    (keydown)="onHandleNotificationsKeyDown(notification, $event)"
                    [ngClass]="notification.isRead ? 'read' : 'unread'">
                    <daisy-avatar class="shrink-0" [initials]="(notification.sender?.firstInitial ?? '') + (notification.sender?.lastInitial ?? '')" size="2.25rem" shape="rounded" />

                    <div class="ml-3 flex w-full flex-col">
                      <div class="flex items-start justify-between">
                        <div>
                          <span class="mr-1 font-semibold">{{ notification.sender?.displayName }}</span>
                          <span class="mr-1">
                            {{ notification.content?.primaryText }}
                          </span>
                          <a class="cursor-pointer font-bold text-daisy-primary" target="_blank"
                            rel="noopener noreferrer" (click)="onHyperLinkClick(notification, $event)"
                            [routerLink]="notification.content?.primaryUrl | routerLinkSafeUrl" daisyTooltip="Navigate to Review">
                            @if (notification.category === NotificationCategory.NarrativeReviews) {
                              Narrative
                            } @else {
                              Incident
                            }
                            Review {{ notification.content?.primaryUrl | urlSegment: 'reviews' }}
                          </a>
                        </div>

                        <div class="ml-2 shrink-0">
                          @if (notification.isRead) {
                            <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-sm text-base-content/60"
                              aria-label="Mark as unread" daisyTooltip="Mark as unread"
                              (click)="onMarkNotificationsReadStatusesClick(notification, false, $event)">
                              <i class="fa-regular fa-circle"></i>
                            </button>
                          } @else {
                            <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-sm text-daisy-primary"
                              aria-label="Mark as read" daisyTooltip="Mark as read"
                              (click)="onMarkNotificationsReadStatusesClick(notification, true, $event)">
                              <i class="fa-solid fa-circle"></i>
                            </button>
                          }
                        </div>
                      </div>

                      <div class="mt-1 flex items-center justify-between">
                        <a class="flex cursor-pointer items-center gap-1 font-bold uppercase text-daisy-primary"
                          [routerLink]="notification.content?.secondaryUrl | routerLinkSafeUrl" (click)="onHyperLinkClick(notification, $event)"
                          daisyTooltip="Navigate to Incident" target="_blank" rel="noopener noreferrer">
                          <i class="fa-solid fa-file-lines"></i>
                          {{ notification?.content?.secondaryText }}
                        </a>
                        <span class="text-base-content/60">
                          {{ notification.createdOn | timeAgo }}
                        </span>
                      </div>
                    </div>
                  </span>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
}
